import React from 'react';
import styled from 'styled-components';

const StyledParamList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.span`
  margin: 5px 0;
`;

const List = styled.div`

`;

const Item = styled.span`
  display: flex;

  strong {
    margin-right: 5px;
  }
`;

const ParamList = ({ params = {} }: any) => {
  const paramList = Object.entries(params);
  return (
    <StyledParamList>
      <Title>Params: </Title>
      <List>
        {paramList.map(([key, value]: any, index: number) => (
          <Item key={index}>
            <strong>{`${key}:`}</strong>
            <span>{`${value}`}</span>
          </Item>
        ))}
      </List>
    </StyledParamList>
  );
};

export default ParamList;
